import {combineReducers} from 'redux';

import authentication from './authentication/reducers'
import customer from './customer/reducers';
import propertyType from './propertyType/reducers';
import location from './location/reducers';
import postData from './postData/reducers';
import property from './property/reducers';
import project from './project/reducers';
import agent from './agent/reducers';

const appReducer = combineReducers({
  authentication,
  customer,
  propertyType,
  location,
  postData,
  property,
  project,
  agent
});

const rootReducer = (state, action) => {
  if (action.type == 'USER_LOGOUT') {
    return appReducer(state = 'undefined', action);
  }
  return appReducer(state, action);
};

export default rootReducer;